const zh = {
  nightMode: '深色模式',
  title: 'TokenPocket ETH 节点质押已稳定运行 2 年多，管理的节点稳定产生收益，节点运行状态行业领先，为管理节点产生约 5% 年化收益；质押方式多，参与方式灵活',
  title_2: '截止到 2022-09-16 00:00 UTC，有参与 TokenPocket Eth2.0 质押宝且累计参与质押量大于等于 0.1 ETH 的用户可领取 $STRK 空投',
  jointStake: '联合质押',
  selfHostStake: '自托管质押',
  totalStake: '总质押 (ETH)',
  totalIncome: '累计收益',
  estimateAnnualized: '预计年化',
  yourEndpointTrend: '您的节点奖励走势',
  day: '24小时',
  month: '近1个月',
  joinStake: '参与质押',
  quitStake: '退出质押',
  inputQuitAmount: '请输入退出额度',
  canQuitAmount: '当前可退出额度为: ',
  canFastQuitAmount: '当前可快速退出额度为: ',
  quitKnow: '* 关于退出质押，请了解',
  quitRules: '《质押宝退出规则》',
  confirmQuit: '确定退出',
  remainingAmount: '剩余额度：',
  inputJointStakeAmount: '请输入联合质押的额度',
  jointStakeMinAmount: '联合质押，最小参与额度为0.1ETH',
  joinAndAgree: '参与即同意',
  stakeVaultServiceProtocol: '《质押宝服务协议》',
  pay: '支付',
  endpointIncome: '节点收益',
  endpointStatus: '节点状态',
  stakeHistory: '质押历史',
  commonQuestion: '常见问题',
  knowledge: '知识',
  knowETHPOS: '了解 ETH POS',
  aboutStakeCommonQustions: '关于质押，常见问题',

  endpont: '节点',
  stakeAmount: '质押数量',
  validTime: '生效时间',
  withdrawalAddress: '提款地址',
  receiveTime: '预计到账时间',
  active: '活跃',
  connectWallet: '连接钱包',
  balance: '余额',
  noData: '暂无数据',
  predictIncome: '预计产生节点奖励: ',
  inputJointStakeAmount: '请输入联合质押的额度',
  jointStakeTip: '联合质押，最少参与额度为0.1 ETH',
  overCount: '最大为32000',
  belowCount: '最小为0.1',
  overActivityCount: '当前快速生效仅可参与{msg}ETH，您如需参与更多，请质押完快速生效额度后继续参与普通质押',
  activityEnd: '快速质押已结束，请继续参与普通质押',
  unknownError: '未知的错误',
  fail: '质押失败',
  success: '参与成功',
  anonymousloginError: '网络错误，请重试',
  aboutUnstake: '* 关于退出质押，请了解<a style="color: #2980FE" href="https://help.tpwallet.io/cn/faq/ethwallet/eth2.0-staking-vault" target="_blank">《质押宝退出规则》</a>',
  aboutStake: '参与即同意<a style="color: #2980FE" href="https://help.tpwallet.io/cn/agreements/eth-2.0-terms" target="_blank">《质押宝服务协议》</a>',
  deposit: ' 已质押，等待创建节点',
  staking: '质押(确认中)',
  unstaking: '赎回请求(处理中)',
  staked: '质押(生效中)',
  unstaked: '赎回请求',
  withdrawal: '提现',
  endpointAmount: '节点数',
  hasStaked: '已质押',
  hasUnstaked: '已退出',
  usedOut: '第一期流动性基金已使用完毕，第二期筹备中，请等待。',
  exitSuccess: '退出成功',
  exitFailed: '退出失败',
  selfHostStakeWarn: '设置质押的节点数，一个节点需质押32 ETH',
  needToStakeAmount: '需要质押的数量',
  endpointStake: '节点质押',
  endpointMaintainFee: '节点维护费',
  amount: '数量',
  one: '个',
  totalFee: '总费用',
  feeDetails: '费用明细',
  endpointCount: '节点数量',
  mobileSelfHostStakeDesc: '您自行持有提款私钥，每次质押至少 32 ETH',
  mobileJointStakeDesc: '与他人共同联合进行节点质押，每次质押至少 0.1 ETH',
  stakeOrUnstake: '参与/退出质押',
  myEndpoints: '我的节点',
  switchWallet: '切换钱包',
  settings: '设置',
  switchLocale: '切换语言',
  overAccount: '余额不足',
  effectiveTime: '生效时间',
  copied: '复制成功',
  endpointStatusMap: {
    0: '待处理',
    1: '链上排队质押中',
    2: '已生效',
    3: '退出中',
    4: '提款中',
    5: '已退出',
  },
  consensusIncome: '共识收益',
  executionIncome: '执行收益',
  total: '总收益',
  networkError: '网络错误，切换网络',
  quitMax1: '当天流动性基金可退出额为：',
  quitMax2: '您当天可以退出最大额为：',
  quitMax3: '您已质押的额度为：',
  quitMin: '最小退出额为：',
  forever: '永久',
  sendKeypal: '赠送硬件钱包',
  editAddress: '编辑地址',
  inputAddress: '填写地址',
  receivePerson: '收货人',
  name: '名字',
  phoneNumber: '手机号码',
  inputPhoneNumber: '请输入手机号',
  emailCode: '邮政编码',
  addressDetails: '详细地址',
  viewAllEndpoints: '查看所有节点',
  endpointListUrl: 'https://help.tpwallet.io/cn/faq/ethwallet/eth2.0-node-list',
  posUrl: 'https://help.tokenpocket.pro/cn/faq/ethwallet/eth2.0/pos',
  commonQuestionUrl: 'https://help.tokenpocket.pro/cn/faq/ethwallet/eth2.0/about-eth-staking',
  selfHostCommonQuestionUrl: 'https://help.tokenpocket.pro/cn/faq/ethwallet/eth2.0/about-self-custodial-staking',
  confirm: '确定',
  txConfirming: '{amount}个交易确认中...',
  endpointFeeTip: '节点维护费用为一次性收费，后续不再收费',
  noHistoryData: '暂无质押记录~',
  noEndpointData: '暂无节点信息~',
  tips: '温馨提示',
  downloadTips: '请您下载TokenPocket进行使用，下载网址：',
  know: '我知道了',
  unknownError: '未知的错误',
  email: '邮箱',

  quit: '快速',
  normal: '普通',
  incomeTitle: '可提现收益',
  withdrawAmount: '可提现额度',
  withdraw: '提现',
  estimateGas: '提现矿工费最大约为',
  withdrawSuccess: '提现成功',
  withdrawFailed: '提现失败',

  withdrawIncomeTips: 'TokenPocket已向信标链发起提取收益请求，待确认后，您即可领取收益',
  unStakeSuccess: '已向节点发起赎回操作，当链上赎回确定后，您可在下方“可提现额度”中进行一次提现操作！',
  quitHandlingFee: '快速退出需收取5%手续费',
  normalQuit: '链上退出',
  fastQuit: '快速退出(流动基金)',
  withdrawTips: '网络费大于提现金额，请勿继续',

  modalTextData: {
    title_1: '关于提现收益',
    desc_1: '由于节点收益提现需通过以太坊信标链排队确认，当TokenPocket向节点发起收益提现并在链上确认后，您即可提现您的收益。您的提现矿工费由TokenPocket帮您代扣！',
    btn_1: '确定',
    
    title_2: '关于链上赎回质押',
    desc_2: '由于节点质押赎回需通过以太坊信标链排队确认，当TokenPocket根据用户需求向节点质押赎回并在链上确认后，您即可提取您的质押！',
    btn_2: '确定',

    title_3: '温馨提示',
    desc_3: 'ETH质押宝将于新加坡时间5月22日9:00PM到5月23日12:00AM进行系统升级，升级期间服务暂停，升级期间不影响您的资产安全，请您放心。升级完成后，可以正常使用！',
    btn_3: '确定',
  },

  details: '查看详情',
  selfHostIncomeUrl: '自动到账',

  self_host_op_type: {
    1: '质押',
    2: '赎回',
    3: '平台提现',
    4: '链上提现',
    5: '快速质押',
    6: '快速赎回',
    7: '快速质押不足（部分退款）',
  }
};

export default zh;
